import BigNumber from 'bignumber.js'
import { ChainId } from '@pancakeswap/sdk'
import smartChefNftABI from '../abis/ISmartChefNFT.json'
import erc721ABI from '../abis/IERC721.json'
import { getNftPoolsConfig } from '../constants'
import { SerializedNftPool, OnChainProvider } from '../types'

const getLiveNftPoolsWithEnd = async (chainId: ChainId) => {
  const poolsConfig = getNftPoolsConfig(chainId)
  if (!poolsConfig) {
    return null
  }
  return poolsConfig.filter((p) => !p.isFinished)
}

async function fetchUpgradedPoolsTimeLimits(pools: SerializedNftPool[], chainId: ChainId, provider: OnChainProvider) {
  if (!pools.length) {
    return []
  }

  const calls = pools.flatMap(({ contractAddress }) => {
    return [
      {
        abi: smartChefNftABI,
        address: contractAddress,
        functionName: 'startTimestamp',
      },
      {
        abi: smartChefNftABI,
        address: contractAddress,
        functionName: 'endTimestamp',
      },
    ] as const
  })

  const client = provider({ chainId })
  const startEndRaw = await client.multicall({
    // @ts-ignore
    contracts: calls,
    allowFailure: false,
  })

  const startEndResult = startEndRaw.reduce<[BigNumber][][]>((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / 2)

    if (!resultArray[chunkIndex]) {
      // eslint-disable-next-line no-param-reassign
      resultArray[chunkIndex] = [] // start a new chunk
    }

    // @ts-ignore
    resultArray[chunkIndex].push(item)

    return resultArray
  }, [])

  return pools.map((dackiePoolConfig, index) => {
    const [startTimestamp, endTimestamp] = startEndResult[index]

    return {
      sousId: dackiePoolConfig.sousId,
      startTimestamp: Number(startTimestamp),
      endTimestamp: Number(endTimestamp),
    }
  })
}

export const fetchNftPoolsTimeLimits = async (chainId: ChainId, provider: OnChainProvider) => {
  const livedPools = await getLiveNftPoolsWithEnd(chainId)
  if (!livedPools) {
    return null
  }
  const [nftPoolLimits] = await Promise.all([fetchUpgradedPoolsTimeLimits(livedPools, chainId, provider)])
  return [...nftPoolLimits]
}

export const fetchNftPoolsTotalStaking = async (chainId: ChainId, provider: OnChainProvider) => {
  const poolsConfig = getNftPoolsConfig(chainId)
  if (!poolsConfig) {
    return null
  }
  const poolsBalanceOf = poolsConfig.map(({ contractAddress, stakingToken }) => {
    return {
      abi: erc721ABI,
      address: stakingToken.address,
      functionName: 'balanceOf',
      args: [contractAddress],
    } as const
  })

  const client = provider({ chainId })
  const poolsTotalStaked = await client.multicall({
    // @ts-ignore
    contracts: poolsBalanceOf,
    allowFailure: false,
  })

  return poolsConfig.map((p, index) => ({
    sousId: p.sousId,
    // @ts-ignore
    totalStaked: new BigNumber(poolsTotalStaked[index]).toJSON(),
  }))
}
